var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "div",
      {
        ref: "autofocus",
        staticClass: "formpart",
        attrs: {
          tabindex: "0",
        },
      },
      [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Frage")) + "\n        "),
        _c("StudipWysiwyg", {
          model: {
            value: _vm.val_clone.description,
            callback: function callback($$v) {
              _vm.$set(_vm.val_clone, "description", $$v)
            },
            expression: "val_clone.description",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("label", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.val_clone.mandatory,
            expression: "val_clone.mandatory",
            modifiers: {
              number: true,
            },
          },
        ],
        attrs: {
          type: "checkbox",
          "true-value": "1",
          "false-value": "0",
        },
        domProps: {
          checked: Array.isArray(_vm.val_clone.mandatory)
            ? _vm._i(_vm.val_clone.mandatory, null) > -1
            : _vm._q(_vm.val_clone.mandatory, "1"),
        },
        on: {
          change: function change($event) {
            var $$a = _vm.val_clone.mandatory,
              $$el = $event.target,
              $$c = $$el.checked ? "1" : "0"
            if (Array.isArray($$a)) {
              var $$v = _vm._n(null),
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(_vm.val_clone, "mandatory", $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.val_clone,
                    "mandatory",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.val_clone, "mandatory", $$c)
            }
          },
        },
      }),
      _vm._v("\n        " + _vm._s(_vm.$gettext("Pflichtfrage")) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }